var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFoodALaCarte = function SvgFoodALaCarte(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 21.2 21.2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "m19.6 17.1-.585 2.05a2 2 0 0 1-1.922 1.45H4.107a2 2 0 0 1-1.922-1.45L1.6 17.1m18 0h1m-1 0h-18m0 0h-1m19.5-3.5v-1.1c0-5.191-4.207-9.4-9.396-9.4h-.2c-5.189 0-9.396 4.209-9.396 9.4v1.1M12.104 3.204V2.1a1.5 1.5 0 1 0-2.999 0v1.104m1.5 3.396c1.775 0 3.371.773 4.47 2"
  })));
};
export default SvgFoodALaCarte;